{
  "access": {
    "forbidden": "You do not have permission to view offers."
  },
  "list": {
    "pageTitle": "Offers",
    "searchPlaceholder": "Search by title, client, or brand...",
    "searchAriaLabel": "Search by title, client, or brand",
    "loading": "Loading offer drafts...",
    "error": "Failed to load offer drafts.",
    "retry": "Try again",
    "missingBrand": "—",
    "missingClient": "No client",
    "views": {
      "mine": "Mine",
      "sharedWithMe": "Shared with me",
      "all": "All",
      "scopeAriaLabel": "Offer scope"
    },
    "assignedTo": {
      "ariaLabel": "Assigned to",
      "placeholder": "Assigned to (everyone)",
      "searchPlaceholder": "Search person...",
      "empty": "Person not found"
    },
    "actions": {
      "newDraft": "New draft",
      "createFirstDraft": "Create first draft"
    },
    "columns": {
      "brand": "Brand",
      "title": "Offer draft",
      "status": "Status",
      "campaignNumber": "Campaign number",
      "validUntil": "Valid until",
      "updatedAt": "Updated"
    },
    "rowLinkAriaLabel": "Open offer {{title}}",
    "emptyState": {
      "title": "No offer drafts",
      "description": "No drafts found for this view. Create the first draft to get started."
    },
    "pagination": {
      "status": "Page {{page}} of {{total}}",
      "prev": "Previous page",
      "next": "Next page"
    },
    "bulkWithdrawAcceptance": {
      "toolbarAction": "Withdraw acceptance",
      "toolbarActionDisabledHint": "Select at least one accepted offer.",
      "toolbarActionAccessRequiredHint": "Selected accepted offers require edit access to withdraw acceptance.",
      "toolbarAriaLabel": "Bulk actions for the selected offers",
      "selectedCountSuffix": "selected",
      "visibleCountSuffix": "visible",
      "moreActionsLabel": "More actions",
      "clearSelectionLabel": "Clear selection",
      "dialog": {
        "title": "Withdraw acceptance (bulk)",
        "loadingPreview": "Checking how many reservations will be released…",
        "description": "You will undo {{offerCount}} acceptances and release {{reservationCount}} reservations.",
        "hiddenNotice": "{{count}} outside the current results.",
        "reasonLabel": "Reason (optional)",
        "cancelBtn": "Cancel",
        "confirmBtn": "Confirm"
      },
      "result": {
        "withdrawnLabel": "Withdrawn",
        "skippedLabel": "Skipped",
        "failedLabel": "Failed",
        "closeBtn": "Close",
        "offerLabel": "Offer #{{offerId}}",
        "skippedTag": "skipped",
        "failedTag": "error: {{errorCode}}",
        "releasedCount": "released {{count}}",
        "reservationId": "Reservation #{{id}}",
        "reservationFailed": "Reservation #{{id}} — error: {{errorCode}}"
      }
    }
  },
  "create": {
    "pageTitle": "New offer draft",
    "title": "New offer draft",
    "description": "Provide a client to start working on an offer.",
    "loading": "Loading clients...",
    "loadError": "Failed to load client list.",
    "retry": "Try again",
    "forbidden": "You do not have permission to create offer drafts.",
    "fields": {
      "brand": "Brand",
      "brandPlaceholder": "Select brand",
      "brandUnavailable": "Client has no brands",
      "brandingMode": "Branding mode",
      "brandingModePlaceholder": "Select branding mode",
      "client": "Client",
      "clientPlaceholder": "Select client",
      "campaignDuration": "Campaign duration",
      "validUntil": "Valid until",
      "datePlaceholder": "Select date…",
      "dateRangePlaceholder": "Select date range…",
      "salesperson": "Salesperson",
      "salespersonPlaceholder": "Select salesperson",
      "salespersonLockedHint": "You don't have permission to assign this offer to another salesperson.",
      "campaignNumberPreview": "Campaign number",
      "campaignNumberPreviewIncomplete": "Select a client and a salesperson to see the campaign number",
      "campaignNumberPreviewLoading": "Loading…",
      "campaignNumberPreviewUnavailable": "Couldn't load the number preview"
    },
    "inlineClient": {
      "showAction": "Create new client",
      "noPermission": "You don't have permission to perform this action.",
      "fields": {
        "name": "Client name"
      }
    },
    "coCreators": {
      "label": "Add co-creators",
      "hint": "Once the offer is created, we'll open the sharing dialog so you can pick people to share editing access with."
    },
    "actions": {
      "cancel": "Cancel",
      "submit": "Create draft"
    },
    "errors": {
      "brandRequired": "Select brand",
      "clientRequired": "Select a client",
      "clientNotFound": "Client not found, select another one",
      "clientSaveError": "Failed to save client",
      "salespersonInvalid": "Invalid salesperson, select another one",
      "campaignNumberExhausted": "Couldn't generate a unique campaign number. Please try again.",
      "saveFailed": "Failed to save draft",
      "addUnitsFailed": "The draft was created, but the selected media units could not be added. Add them manually from the Units tab.",
      "dateRangeInvalid": "The end date must be on or after the start date"
    }
  },
  "workspace": {
    "pageTitle": "Offer",
    "loading": "Loading offer draft...",
    "error": "Failed to load offer draft.",
    "forbidden": "You do not have access to this offer draft.",
    "inTrash": "In trash",
    "tabPlaceholder": "This view is coming soon.",
    "unitsTab": {
      "loading": "Loading media units...",
      "error": "Failed to load media units.",
      "empty": {
        "title": "Offer is empty",
        "description": "Add media units to start building the offer. You can use search, map, AI suggestions, or ready-made packages.",
        "primaryAction": "Add first media unit",
        "importPackage": "Import package"
      },
      "noResults": {
        "title": "No results",
        "description": "None of the offer's {{count}} media units match the current filter.",
        "clearFilters": "Clear filters"
      },
      "costs": {
        "maskedExplanation": "You don't have permission to view this value."
      },
      "supplierMaskedExplanation": "You don't have permission to view this value.",
      "footer": {
        "unitCountSingular": "{{count}} media unit",
        "pricedCount": "{{count}} priced",
        "soldCount": "{{count}} sold",
        "totalPrice": "Total: {{value}}"
      },
      "columns": {
        "checkbox": "",
        "id": "ID",
        "identifier": "GRW number",
        "location": "Location",
        "audience": "Audience",
        "clientDecision": "Client",
        "format": "Format",
        "supplier": "Supplier",
        "dimensions": "Dimensions",
        "lighting": "Lighting",
        "note": "Note",
        "actions": ""
      },
      "decision": {
        "accepted": "Accepted",
        "rejected": "Rejected",
        "undecided": "Pending",
        "notInVersion": "Not in selected version",
        "unavailable": "Unavailable"
      },
      "filterFields": {
        "region": "Region",
        "county": "County",
        "agglomeration": "Agglomeration",
        "city": "City",
        "mediaType": "Media type",
        "locationSearchPlaceholder": "Search region, county, agglomeration, city…",
        "locationInfoHint": "Selected areas are combined (OR) — add locations to broaden results. Other filters narrow the result.",
        "locationInfoHintLabel": "Location filter information",
        "lighting": "Lighting",
        "supplierNumber": "Supplier no.",
        "grwId": "GRW ID",
        "searchPlaceholder": "Search by number, address, city...",
        "searchAriaLabel": "Search media units",
        "material": "Material",
        "multiformat": "Multiformat",
        "tags": "Tags",
        "address": "Address",
        "area": "Area",
        "width": "Width",
        "height": "Height",
        "audience": "Audience",
        "catalogPrice": "Catalog price",
        "rent": "Rent",
        "exposureCost": "Exposure cost",
        "additionalCosts": "Additional costs",
        "discountedPrice": "Discounted price",
        "lastMinutePrice": "Last minute price",
        "starterPrice": "Starter price",
        "productionCost": "Production cost",
        "installationCost": "Installation cost",
        "dismantlingCost": "Dismantling cost",
        "clientProduction": "Production",
        "clientInstallation": "Installation",
        "clientDismantling": "Dismantling",
        "clientAdditionalFees": "Additional fees",
        "notes": "Notes",
        "roadNumber": "Road number",
        "rangeMinLabel": "Min",
        "rangeMaxLabel": "Max"
      },
      "checkboxAriaLabel": "Select media unit {{id}}",
      "rowLinkAriaLabel": "Open media unit details {{id}}",
      "noteInputAriaLabel": "Note for media unit {{id}}",
      "noteInputPlaceholder": "Add note...",
      "columnVisibility": {
        "toggleButton": "Columns",
        "sectionLabel": "Column visibility",
        "searchPlaceholder": "Search columns...",
        "noResults": "No column found"
      },
      "toolbar": {
        "addUnits": "Add media units",
        "addUnitsPrimaryAriaLabel": "Add media units to offer",
        "addUnitsMenuAriaLabel": "More add options",
        "addModes": {
          "search": "Search and add",
          "map": "Pick from map",
          "package": "Pick from package",
          "ai": "AI suggestions",
          "comingSoon": "Coming soon"
        },
        "unitCount": "{{count}} media units",
        "unitCountOfTotal": "{{count}} of {{total}} media units",
        "sortChipLabel": "Sorting: {{column}} {{direction}}",
        "sortChipClearAriaLabel": "Clear sort, restore the add order"
      },
      "placeholder": "-",
      "map": {
        "toggle": "Map",
        "empty": "No units with coordinates to display on the map.",
        "popupDetails": "Details"
      },
      "toasts": {
        "noteConflict": "This offer was just updated by another user. Note was not saved.",
        "noteSaved": "Note saved",
        "noteSaveError": "Failed to save note for media unit.",
        "removeSuccess": "Removed selected media units from the offer"
      },
      "bulkActions": {
        "removeSelected": "Remove selected",
        "selectedCount": "selected",
        "visibleCount": "visible",
        "moreActions": "More",
        "clearSelection": "Clear selection",
        "ariaLabel": "Actions for selected media units"
      },
      "removeConfirm": {
        "title": "Remove selected media units",
        "description": "Are you sure you want to remove selected media units from this offer? This action cannot be undone.",
        "reservationNotice": "{{reserved}} of {{total}} selected media units carry a reservation held by this offer — it will be released.",
        "hiddenNotice": "{{count}} outside the current results.",
        "cancel": "Cancel",
        "confirm": "Remove"
      },
      "addDrawer": {
        "title": "Add media units",
        "searchPlaceholder": "Search by ID, city, or format...",
        "searchAriaLabel": "Search media units",
        "addButton": "Add selected",
        "addButtonAriaLabel": "Add selected media units to offer",
        "cancelButton": "Cancel",
        "cancelButtonAriaLabel": "Cancel adding media units",
        "closeAriaLabel": "Close add media units drawer",
        "loading": "Loading media units...",
        "error": "Failed to load media units.",
        "empty": "No media units to display.",
        "selectedCount": "{{count}} selected",
        "columns": {
          "select": "",
          "photo": "Photo",
          "grwId": "ID",
          "city": "City",
          "address": "Address",
          "format": "Format",
          "supplier": "Supplier",
          "dimensions": "Dimensions",
          "status": "Status"
        },
        "photoAlt": "Photo of unit {{grwId}}",
        "noPhoto": "No photo"
      },
      "mapOverlay": {
        "title": "Select units from map",
        "availableOnly": "Show available only",
        "selectedCount": "{{count}} units selected",
        "addButton": "Add {{count}} units",
        "cancel": "Cancel",
        "error": "Failed to add units. Please try again."
      },
      "horizontalScrollbarAriaLabel": "Units table horizontal scroll"
    },
    "pricingTab": {
      "loading": "Loading pricing...",
      "error": "Failed to load pricing.",
      "columns": {
        "identifier": "GRW number",
        "unit": "Media unit",
        "location": "Location",
        "dimensions": "Dimensions",
        "clientPriceNet": "Client net price",
        "clientPriceNetAriaLabel": "Client net price",
        "discountPercent": "Discount %",
        "discountPercentAriaLabel": "Discount percentage",
        "lineTotal": "Amount",
        "emptyPrice": "—",
        "checkboxAriaLabel": "Select row {{id}}"
      },
      "totals": {
        "subtotal": "Net subtotal",
        "discount": "Discount",
        "grandTotal": "Net total",
        "additionalServices": "Additional services"
      },
      "toolbar": {
        "applyDiscount": "Apply discount",
        "applyDiscountAriaLabel": "Apply discount to selected rows",
        "discountPopoverSelected": "Apply discount to {{count}} selected rows",
        "discountPopoverHiddenCount": "{{count}} outside the current results.",
        "discountPopoverAll": "Apply discount to all rows",
        "discountInputAriaLabel": "Discount value in percent",
        "discountCancel": "Cancel",
        "discountSubmit": "Apply",
        "discountSubmitAriaLabel": "Confirm applying the discount"
      },
      "confirmDialog": {
        "title": "Apply discount to all rows",
        "description": "A {{discountPercent}}% discount will be applied to {{count}} rows.",
        "rowCount": "Row count: {{count}}",
        "filterDoesNotNarrow": "The discount reaches every unit in the offer, not only the ones the filter is showing.",
        "overwriteWarning": "{{count}} rows already have a discount set — it will be overwritten.",
        "loadingRows": "Loading rows…",
        "cancel": "Cancel",
        "confirm": "Apply to all",
        "confirmAriaLabel": "Confirm applying the discount to all rows",
        "closeAriaLabel": "Close confirmation"
      },
      "toasts": {
        "conflict": "This offer was updated by another user. The price was not saved.",
        "saveError": "Failed to save the price."
      },
      "mixedCurrencyWarning": "Set a single currency to see totals."
    },
    "tabs": {
      "units": "Media units",
      "comments": "Comments",
      "versions": "Versions",
      "decisions": "Client decisions"
    },
    "versions": {
      "toolbar": {
        "title": "Version history",
        "publishBtn": "Publish new version"
      },
      "emptyState": {
        "title": "The offer has not been published yet.",
        "description": "Publish the first version to share the offer with the client and start tracking the change history.",
        "publishFirstBtn": "Publish first version"
      },
      "statusLabel": {
        "PUBLISHED": "Published",
        "SUPERSEDED": "Superseded",
        "ACCEPTED": "Accepted"
      },
      "rejectedBadge": "Rejected",
      "activeVersionLabel": "Active version",
      "versionBadge": "v{{number}}",
      "publishedBy": "by user {{id}}",
      "publishedByName": "by {{name}}",
      "unitCount": "{{count}} media units",
      "actionsLabel": "Actions",
      "previewTooltip": "Preview version",
      "snapshot": {
        "loading": "Loading archived version...",
        "error": "Failed to load the archived version.",
        "notFound": "The archived version does not exist.",
        "forbidden": "No access to this archived version.",
        "archivalBanner": "This is an archived view of version v{{number}}. This version is not active.",
        "decisionsErrorBanner": "Could not load the client's decisions for this version. The numbers below may not reflect the actual decisions.",
        "previewHint": "Archived preview — actions are not available.",
        "backLink": "Back to version history"
      },
      "editGateBanner": {
        "title": "This offer is published. Editing requires publishing a new version.",
        "statusSent": "Status: Sent",
        "statusAccepted": "Status: Accepted — editing may require the client to re-accept.",
        "statusConfirmed": "Status: Confirmed — editing may affect the confirmed campaign.",
        "statusSold": "Status: Sold — editing may affect the sold campaign.",
        "viewVersionsBtn": "View version history",
        "cancelledTitle": "This campaign has been cancelled. Editing is unavailable."
      },
      "publishDialog": {
        "title": "Publish new version",
        "descriptionLabel": "Description of changes",
        "descriptionPlaceholder": "Describe what changed in this version...",
        "charCounter": "{{current}} / 500 characters",
        "confirmBtn": "Publish",
        "cancelBtn": "Cancel",
        "successToast": "Version published",
        "staleError": "This offer was updated by someone else. Refresh the page and try again.",
        "validationError": "The description of changes is invalid.",
        "genericError": "Failed to publish the version."
      },
      "diff": {
        "dialogTitle": "Version comparison",
        "dialogSubtitle": "{{from}} → {{to}}",
        "loading": "Loading differences...",
        "error": "Failed to load the differences.",
        "empty": "No differences between versions",
        "closeAriaLabel": "Close comparison",
        "closeBtn": "Close",
        "compareBtn": "Compare with previous",
        "summary": {
          "addedLabel": "Added",
          "removedLabel": "Removed",
          "changedLabel": "Changed",
          "netValueLabel": "Net value"
        },
        "section": {
          "addedTitle": "Added media units ({{count}})",
          "removedTitle": "Removed media units ({{count}})",
          "changedTitle": "Changed media units ({{count}})"
        },
        "fieldLabel": {
          "clientPriceNet": "Client price (net)",
          "discountPercent": "Discount",
          "dateFrom": "Start date",
          "dateTo": "End date"
        }
      },
      "lock": {
        "dialog": {
          "title": "Reserve media units",
          "description": "Choose the reservation type that will be created for every media unit in this offer version.",
          "statusLabel": "Reservation type",
          "statusSoftReservation": "Soft reservation",
          "statusOption": "Option",
          "optionNeverQueuesHint": "An option never joins the waiting queue — if there's a conflict, the reservation will fail instead.",
          "sharedExpiryLabel": "Expiry date",
          "sharedExpiryHint": "One shared expiry date for the whole set — it also applies to media units that end up queued. The system suggests an expiry date; you can change it using the calendar.",
          "confirmBtn": "Reserve",
          "cancelBtn": "Cancel",
          "breakdown": {
            "loading": "Working out what reserving would do…",
            "error": "We couldn't work out what reserving would do.",
            "retryBtn": "Try again",
            "empty": "There's nothing to reserve — every accepted media unit is already held by this campaign.",
            "lockableLabel": "Will be reserved",
            "alreadyHeldLabel": "Already held",
            "queuedLabel": "Will be queued",
            "unresolvableLabel": "Can't be reserved",
            "contendedNote": "The outcome for queued media units can change before the reservation is confirmed."
          }
        },
        "result": {
          "lockedLabel": "Reserved",
          "queuedLabel": "Queued",
          "failedLabel": "Failed",
          "lockedEmpty": "No media units were reserved.",
          "queuedEmpty": "No media units are queued.",
          "failedEmpty": "No failures.",
          "unknownUnit": "Unknown media unit",
          "entryQueuedPosition": "Queue position: {{position}}",
          "entryExpiresOn": "Expires {{date}}",
          "entryFailedMinWindowViolationGeneric": "The accepted period is shorter than the minimum reservation window for this media unit. Extend the period and try again.",
          "entryFailedReservationConflict": "This period is already taken by another reservation.",
          "entryFailedAvailabilityWindowBlocked": "The selected period is blocked by the media unit's unavailability window.",
          "entryFailedGeneric": "This media unit could not be reserved.",
          "closeBtn": "Close"
        },
        "toasts": {
          "notAccepted": "Cannot reserve media units — this version is no longer accepted."
        }
      },
      "withdrawAcceptance": {
        "withdrawButton": "Withdraw acceptance",
        "registerRejectionButton": "Record rejection",
        "dialog": {
          "withdrawTitle": "Withdraw acceptance",
          "withdrawDescription": "Withdrawing the acceptance will release every reservation locked for this version.",
          "registerRejectionTitle": "Record rejection",
          "registerRejectionDescription": "We'll record that the client rejected this offer version. This does not affect any reservations.",
          "reasonLabel": "Reason (optional)",
          "cancelBtn": "Cancel",
          "confirmBtn": "Confirm",
          "supersededMessage": "This version has been superseded by a newer one. Refresh the page and try again.",
          "breakdown": {
            "loading": "Working out what withdrawing would release…",
            "error": "We couldn't work out what withdrawing would release.",
            "retryBtn": "Try again",
            "empty": "Nothing will be released — no hold was ever taken for this version.",
            "releasableLabel": "Will be released",
            "unresolvableLabel": "Can't be released",
            "unresolvableSoldReason": "The reservation has been sold — the media unit will be left unchanged."
          }
        },
        "result": {
          "releasedLabel": "Released",
          "failedLabel": "Failed",
          "unknownUnit": "Unknown media unit",
          "closeBtn": "Close"
        }
      },
      "unitDecisions": {
        "statusAccepted": "Accepted",
        "statusRejected": "Rejected",
        "statusUndecided": "Pending",
        "statusUndecidedTooltip": "The client hasn't made a decision on this unit.",
        "statusSilent": "Accepted — no available dates",
        "statusSilentTooltip": "The client tried to accept this unit, but none of the offered dates were still available. This is not a missing decision.",
        "summary": {
          "acceptedLabel": "Accepted",
          "silentHintAriaLabel": "Information about acceptances with no available dates",
          "silentHint_one": "Including {{count}} acceptance with no available dates — the client tried to accept, but no date was still free. These units will not be reserved.",
          "silentHint_other": "Including {{count}} acceptances with no available dates — the client tried to accept, but no date was still free. These units will not be reserved.",
          "rejectedLabel": "Rejected",
          "undecidedLabel": "Pending",
          "acceptedValueLabel": "Accepted value",
          "legendAccepted": "accepted {{count}} ({{pct}}%)",
          "legendRejected": "rejected {{count}} ({{pct}}%)",
          "legendUndecided": "pending {{count}} ({{pct}}%)"
        },
        "toolbar": {
          "searchPlaceholder": "Search: address, GRW, supplier no…",
          "searchAriaLabel": "Search media unit",
          "filterAll": "All",
          "filterAccepted": "Accepted",
          "filterRejected": "Rejected",
          "filterUndecided": "Pending",
          "shownLabel": "{{shown}} of {{total}} media units"
        },
        "table": {
          "colDecision": "Decision",
          "colUnit": "Media unit",
          "colType": "Type / dimensions",
          "colAcceptedDates": "Accepted dates",
          "colPrice": "Price",
          "colReservation": "Reservation",
          "noAcceptedDates": "No available dates",
          "reservationNone": "None",
          "reservationSoft": "Soft reservation",
          "reservationOption": "Option",
          "reservationSold": "Sold",
          "emptyTitle": "No media units match the criteria",
          "emptyDescription": "Change the filter or clear the search.",
          "clearFiltersBtn": "Clear filters",
          "sortLabel": "Sort: {{field}} {{dir}}"
        },
        "release": {
          "dialog": {
            "breakdown": {
              "loading": "Working out what releasing would do…",
              "error": "We couldn't work out what releasing would do.",
              "retryBtn": "Try again",
              "empty": "There's nothing to release — the client hasn't rejected any media unit.",
              "releasedLabel": "Will be released",
              "nothingToReleaseLabel": "No active reservation",
              "unresolvableLabel": "Can't be resolved",
              "unresolvableSoldReason": "The reservation has been sold — the media unit will be left unchanged."
            }
          },
          "result": {
            "releasedLabel": "Released",
            "nothingToReleaseLabel": "Nothing to release",
            "failedLabel": "Failed",
            "releasedEmpty": "No media units were released.",
            "nothingToReleaseEmpty": "Every rejected media unit had an active reservation.",
            "failedEmpty": "No failures.",
            "unknownUnit": "Unknown media unit"
          }
        },
        "remove": {
          "button": "Remove rejected units",
          "disabledHint": "No rejected media units to remove",
          "dialog": {
            "title": "Remove rejected units",
            "description": "Media units the client rejected in this version will leave the offer draft. If they still carry an active reservation, it will be released in the same step.",
            "confirmBtn": "Remove",
            "cancelBtn": "Cancel",
            "breakdown": {
              "loading": "Working out what removing would do…",
              "error": "We couldn't work out what removing would do.",
              "retryBtn": "Try again",
              "empty": "There's nothing to remove — the client hasn't rejected any media unit.",
              "removedLabel": "Will be removed",
              "unresolvableLabel": "Can't be removed",
              "unresolvableSoldReason": "The reservation has been sold — the media unit will be left unchanged."
            }
          },
          "result": {
            "removedLabel": "Removed",
            "failedLabel": "Failed",
            "removedEmpty": "No media units were removed.",
            "failedEmpty": "No failures.",
            "unknownUnit": "Unknown media unit",
            "closeBtn": "Close"
          }
        }
      }
    },
    "decisions": {
      "emptyNoVersions": "This offer has no published version yet.",
      "versionSelectLabel": "Version",
      "versionOptionLabel": "v{{number}} — {{status}}"
    },
    "availabilityTab": {
      "loading": "Loading availability...",
      "error": "Failed to load availability.",
      "noDefaultDateRange": "To see availability, set a default date range on this offer.",
      "setDefaultDateRangeCta": "Set campaign duration",
      "noUnits": "This offer doesn't have any media units yet.",
      "toggleLabel": "Availability",
      "granularityLabel": "Granularity",
      "granularityOptions": {
        "day": "Days",
        "week": "Weeks",
        "halfMonth": "Half-month",
        "month": "Months"
      },
      "unitHeader": "Unit / City",
      "soldLabel": "Sold",
      "conflict": {
        "sold": "Sold",
        "reservedOther": "Reserved",
        "optionOther": "Option",
        "softReservation": "Soft reservation",
        "hardReservation": "Hard reservation",
        "cancelSoldBtn": "Cancel sale"
      },
      "popover": {
        "reserveMulti": "Reserve {{count}} periods for {{unitLabel}}: {{periods}}?",
        "reserveSingle": "Reserve period: {{period}} for {{unitLabel}}?",
        "releaseLabel": "Release reservation?",
        "occupiedByOther": "Occupied by another offer",
        "periodPlural": "periods",
        "autoSnapWarning": "{{mediaTypeLabel}} does not support daily reservations. Will reserve period {{snappedLabel}}.",
        "addOptionBtn": "Add option",
        "reserveBtn": "Reserve",
        "upgradeHardBtn": "Hard",
        "closeSaleBtn": "Close sale",
        "releaseBtn": "Yes, release",
        "cancelBtn": "Cancel",
        "closeBtn": "Close"
      },
      "countdown": {
        "label": "Expires in:"
      },
      "toasts": {
        "reservationConflict": "This date is already taken by another reservation.",
        "optionExtensionImpossible": "Cannot extend the option – the date is blocked by another reservation.",
        "staleState": "The reservation state changed before the action was performed. Refresh the page and try again.",
        "notFound": "Reservation or media unit variant not found.",
        "forbidden": "You don't have permission to perform this action.",
        "validationError": "Invalid reservation data.",
        "availabilityWindowBlocked": "Cannot create the reservation – the selected date is blocked by a media unit unavailability window.",
        "minWindowViolation_one": "The minimum reservation period for this media type is {{minWindowDays}} day (you selected {{selectedDays}}).",
        "minWindowViolation_other": "The minimum reservation period for this media type is {{minWindowDays}} days (you selected {{selectedDays}}).",
        "genericError": "Failed to perform the action on the reservation."
      }
    },
    "header": {
      "campaignNumber": "Campaign number",
      "campaignDurationUnset": "Set campaign duration",
      "missingClient": "No client",
      "moreActions": "More options",
      "validityCountdown": "Valid for {{days}} more days",
      "actions": {
        "confirmCampaign": "Confirm campaign",
        "secureRemainingUnits": "Secure remaining units",
        "recordSale": "Confirm sale",
        "adminChangeStatus": "Admin: change status",
        "downloadOrderDocument": "Download order",
        "reservePreliminary": "Reserve preliminarily"
      },
      "reservePreliminaryDialog": {
        "title": "Reserve preliminarily — version {{number}}",
        "reserveGroupLabel": "To be reserved",
        "releaseGroupLabel": "To be released",
        "confirmBtn": "Reserve preliminarily",
        "cancelBtn": "Cancel",
        "closeBtn": "Close",
        "resultReserveTitle": "Reservation result",
        "resultReleaseTitle": "Release result",
        "resultReserveFailed": "Reserving media units failed. Try again.",
        "resultReleaseFailed": "Releasing rejected units' reservations failed. Try again."
      },
      "finalizationPanel": {
        "title": "Campaign finalization",
        "ariaLabel": "Campaign finalization progress",
        "steps": {
          "clientAcceptance": "Client acceptance",
          "campaignConfirmation": "Campaign confirmation",
          "sale": "Sale"
        },
        "stepStatus": {
          "done": "Done",
          "current": "Current step",
          "upcoming": "Upcoming step"
        },
        "draft": {
          "readyToShare": "The offer is being prepared. To move forward, share it with the client using the “Share with client” button above.",
          "needsUnits": "The offer is being prepared. Start by adding media units in the Media units tab."
        },
        "sent": {
          "title": "Step 1 of 3 — Waiting on the client's decision",
          "description": "The next steps (campaign confirmation, sale) unlock once the client accepts the offer."
        },
        "accepted": {
          "title": "Step 2 of 3 — Confirm the campaign",
          "description": "Turns the preliminary holds into hard reservations for the units the client accepted. Skipping this step risks them expiring.",
          "blockedNote": "You don't have permission to confirm the campaign — ask someone with edit access to this offer.",
          "reserveBlockedNote": "You don't have permission to preliminarily reserve media units — ask someone with edit access to this offer and reservation-management permission.",
          "reserveDisabledHint": "There's nothing to reserve or release for this version."
        },
        "confirmed": {
          "title": "Step 3 of 3 — Confirm the sale",
          "description": "Units are secured with a hard reservation under number {{campaignNumber}}. Confirming the sale will close them as sold.",
          "unsecuredAlert": "Some units accepted after the campaign confirmation don't have a hard reservation yet.",
          "secureBlockedNote": "You don't have permission to secure the remaining units — ask someone with edit access to this offer.",
          "blockedNote": "You don't have permission to confirm the sale — ask someone with edit access to this offer."
        },
        "sold": {
          "title": "Campaign sold",
          "description": "All finalization steps are closed. The order document stays available as the record of what was sold."
        },
        "orderDocument": {
          "draftLabel": "Download order (draft)",
          "draftHint": "This offer doesn't have a campaign number yet (a legacy offer) — the document is marked DRAFT until one is assigned."
        }
      },
      "confirmDialog": {
        "title": "Confirm campaign",
        "description": "This action will secure the client's accepted media units for this campaign.",
        "helpText": "This step is irreversible without administrator action.",
        "cancel": "Cancel",
        "confirm": "Confirm campaign",
        "close": "Close campaign confirmation",
        "loadingBreakdown": "Checking what confirming this campaign will change…",
        "breakdownError": "Couldn't check what confirming this campaign will change. Refresh and try again.",
        "retry": "Try again",
        "nothingToSecure": "There's nothing left to secure — every accepted unit is already secured.",
        "queueNote": "Joining the queue records the campaign's interest in this slot — it doesn't secure the unit."
      },
      "saleDialog": {
        "title": "Confirm sale",
        "loadingPreview": "Checking how many units will be closed…",
        "previewError": "Couldn't check which units this sale will close. Refresh and try again.",
        "nothingToClose": "This campaign has no active reservations to close.",
        "description_one": "This action will close {{count}} unit as sold.",
        "description_other": "This action will close {{count}} units as sold.",
        "helpText": "Use this action for an order paid in full. If the order was only partly paid, close each unit individually from the reservation surfaces, then record the campaign sale once the rest follows.",
        "cancel": "Cancel",
        "confirm": "Confirm sale",
        "close": "Close sale confirmation",
        "closedStat": "To close",
        "skippedStat": "Skipped",
        "skippedHintLabel": "Why these units will be skipped",
        "skippedHint_one": "This unit has an active reservation on this offer, but the client hasn't accepted it in the current offer version, so it won't be sold with the campaign by default. Check the option below to sell it anyway.",
        "skippedHint_other": "These units have an active reservation on this offer, but the client hasn't accepted them in the current offer version, so they won't be sold with the campaign by default. Check the option below to sell them anyway.",
        "includeNotAccepted_one": "Also sell the unit outside the client's acceptance ({{count}})",
        "includeNotAccepted_other": "Also sell the units outside the client's acceptance ({{count}})",
        "columns": {
          "outcome": "Sale",
          "periods": "Periods",
          "reservationStatus": "Reservation"
        },
        "outcome": {
          "willClose": "Will be sold",
          "skipped": "Skipped",
          "alreadySold": "Already sold"
        }
      },
      "outcomeBreakdown": {
        "columns": {
          "outcome": "Outcome",
          "period": "Period"
        },
        "group": {
          "newlyReserved": "Newly reserved",
          "raisedFromPreliminary": "Raised from preliminary hold",
          "alreadySecured": "Already secured",
          "queued": "Queued",
          "notSecured": "Could not be secured",
          "sold": "Sold",
          "alreadySold": "Already sold",
          "skippedNotAccepted": "Skipped (outside acceptance)",
          "notClosed": "Could not be closed",
          "unrecognized": "Unrecognised outcome"
        },
        "queuePosition": "Queue position: {{position}}",
        "unrecognizedHint": "This outcome isn't supported by this version of the app yet. Reload the page to see the full detail.",
        "contendedNote": "The outcome for nośniki depending on another party's hold can still change before the action is committed."
      },
      "statusDialog": {
        "title": "Change offer status",
        "description": "New status: {{status}}",
        "reasonLabel": "Reason for status change",
        "reasonPlaceholder": "Describe the reason for the status change",
        "cancel": "Cancel",
        "submit": "Save status",
        "close": "Close status change",
        "errors": {
          "reasonMin": "The reason must be at least 5 characters long.",
          "reasonMax": "The reason cannot exceed 500 characters."
        }
      },
      "menu": {
        "clientShare": "Share with client...",
        "edit": "Edit",
        "manageSharing": "Manage sharing",
        "moveToTrash": "Move to trash",
        "cancelCampaign": "Cancel campaign",
        "editCampaignNumber": "Change campaign number"
      },
      "cancelDialog": {
        "title": "Cancel campaign",
        "description": "The campaign will get the Cancelled status. This does not release its reservations — they stay unchanged.",
        "reasonLabel": "Cancellation reason",
        "reasonPlaceholder": "Describe the reason for cancelling the campaign",
        "cancel": "Back",
        "confirm": "Cancel campaign",
        "close": "Close cancel campaign",
        "errors": {
          "reasonMin": "The reason must be at least 5 characters long.",
          "reasonMax": "The reason cannot exceed 500 characters."
        }
      },
      "campaignNumberDialog": {
        "title": "Change campaign number",
        "description": "Override the already-assigned campaign number, e.g. by appending initials or a month.",
        "fieldLabel": "Campaign number",
        "cancel": "Cancel",
        "confirm": "Save number",
        "close": "Close change campaign number",
        "errors": {
          "required": "Enter a campaign number.",
          "tooLong": "The campaign number cannot exceed 64 characters."
        }
      },
      "clientShare": {
        "title": "Share with client",
        "trigger": "Share with client",
        "close": "Close share with client",
        "infoLabel": "More information",
        "linkSection": "Public link for the client",
        "linkInfo": "Anyone with this link can view the offer without signing in. Generating a new link invalidates the previous one.",
        "previewSection": "Client view",
        "previewInfo": "Opens the offer exactly as the client will see it — without affecting open statistics.",
        "openPreview": "Open preview",
        "requiresPreviewPublish": "Publish the offer to open the client preview."
      },
      "sharing": {
        "actions": {
          "addRole": "Add role",
          "addUser": "Add user",
          "cancel": "Cancel",
          "remove": "Remove",
          "save": "Save sharing"
        },
        "close": "Close sharing management",
        "currentShares": "Current shares",
        "empty": "No shares.",
        "fields": {
          "role": "Role",
          "rolePermission": "Role permission level",
          "rolePlaceholder": "Select role",
          "user": "User",
          "userPermission": "User permission level",
          "userPlaceholder": "Select user"
        },
        "permissions": {
          "view": "View",
          "viewEdit": "View + edit"
        },
        "removeAriaLabel": "Remove share {{id}}",
        "roleFallback": "Role #{{id}}",
        "title": "Manage sharing",
        "toasts": {
          "saveError": "Failed to save sharing changes."
        },
        "userFallback": "User #{{id}}"
      },
      "trash": {
        "actions": {
          "cancel": "Cancel",
          "confirm": "Move to trash",
          "confirmAriaLabel": "Confirm move to trash"
        },
        "close": "Close move to trash confirmation",
        "description": "Moved draft will disappear from My offers and remain only in trash.",
        "title": "Move to trash",
        "toasts": {
          "error": "Failed to move draft to trash."
        }
      },
      "drawer": {
        "cancel": "Cancel",
        "close": "Close edit panel",
        "save": "Save",
        "title": "Edit offer"
      },
      "fields": {
        "brand": "Brand",
        "brandingMode": "Branding mode",
        "campaignDuration": "Campaign duration",
        "datePlaceholder": "Select date…",
        "dateRangePlaceholder": "Select date range…",
        "defaultDateFrom": "Campaign duration — from",
        "defaultDateTo": "Campaign duration — to",
        "defaultPeriodGranularity": "Default period granularity",
        "notificationEmails": "Notification emails",
        "priceColumnsConfig": "Price column definitions",
        "publishWithoutPrices": "Publish without prices",
        "title": "Offer title",
        "validUntil": "Offer valid until"
      },
      "options": {
        "noBrand": "No brand",
        "brandingMode": {
          "rwGroup": "Grupa RW",
          "whiteLabel": "White label"
        },
        "periodGranularity": {
          "halfMonth": "Half month",
          "month": "Month",
          "week": "Week"
        }
      },
      "toasts": {
        "approved": "The campaign has been confirmed. Assigned number: {{campaignNumber}}.",
        "approvalPartial_one": "{{count}} unit could not be secured.",
        "approvalPartial_other": "{{count}} units could not be secured.",
        "approvalConflict": "The offer status changed earlier. Refresh the view and try again.",
        "approvalForbidden": "You don't have permission to confirm this campaign.",
        "approvalError": "Failed to confirm the campaign.",
        "approvalUnrecognizedOutcome": "Some confirmation results aren't supported by this version of the app yet. Reload the page to see the full detail.",
        "conflict": "This offer was just updated by another user.",
        "saveError": "Failed to save changes.",
        "saved": "Saved",
        "statusConflict": "The offer status changed earlier. Refresh the view and try again.",
        "statusForbidden": "You don't have permission to change the offer status.",
        "statusSaved": "Offer status changed to {{status}}. Campaign number: {{campaignNumber}}.",
        "statusSaveError": "Failed to change the offer status.",
        "statusUnchanged": "Choose a different offer status to save the change.",
        "statusValidation": "Fix the form data and try again.",
        "cancelled": "The campaign has been cancelled.",
        "cancelAlreadyCancelled": "This campaign is already cancelled.",
        "cancelForbidden": "You don't have permission to cancel this campaign.",
        "cancelOfferTrashed": "This offer has been moved to trash.",
        "cancelError": "Failed to cancel the campaign.",
        "campaignNumberUpdated": "The campaign number has been changed.",
        "campaignNumberTaken": "This campaign number is already used by another offer.",
        "campaignNumberNotAllocated": "This offer does not have an assigned campaign number yet.",
        "campaignNumberForbidden": "You don't have permission to change the campaign number.",
        "campaignNumberOfferTrashed": "This offer has been moved to trash.",
        "campaignNumberError": "Failed to save the campaign number.",
        "orderDocumentNoAcceptedVersion": "This offer doesn't have an accepted version yet.",
        "orderDocumentNoAcceptedUnits": "This offer has no accepted media units.",
        "orderDocumentUnpricedWarning_one": "Order document downloaded, but {{count}} item doesn't have a price yet.",
        "orderDocumentUnpricedWarning_other": "Order document downloaded, but {{count}} items don't have a price yet.",
        "orderDocumentTooManyUnits": "Too many accepted units to generate the document.",
        "orderDocumentMixedCurrency": "The accepted units use different currencies — one document can't be generated.",
        "orderDocumentError": "Failed to download the order.",
        "saleRecorded_one": "Sale recorded. Closed {{count}} unit as sold.",
        "saleRecorded_other": "Sale recorded. Closed {{count}} units as sold.",
        "saleRecordedZero": "The campaign is now recorded as sold. No unit needed closing.",
        "salePartial_one": "{{count}} unit could not be closed.",
        "salePartial_other": "{{count}} units could not be closed.",
        "saleSkipped_one": "Skipped {{count}} unit outside the client's acceptance.",
        "saleSkipped_other": "Skipped {{count}} units outside the client's acceptance.",
        "saleConflict": "The campaign status changed earlier. Refresh the view and try again.",
        "saleForbidden": "You don't have permission to record the sale of this campaign.",
        "saleError": "Failed to record the campaign sale."
      }
    }
  },
  "clientOffer": {
    "loading": "Loading offer...",
    "error": "Failed to load the offer.",
    "notPublished": "This offer has not been published yet.",
    "status": {
      "accepted": "Accepted"
    },
    "footer": {
      "supersededMessage": "Refresh the page to see the latest version."
    },
    "noPickablePeriodsHint": "No available periods to select",
    "acceptedDecisionsDroppedWarning_one": "Note: {{count}} accepted unit was not saved. Please contact your offer's account manager.",
    "acceptedDecisionsDroppedWarning_other": "Note: {{count}} accepted units were not saved. Please contact your offer's account manager.",
    "inquiry": {
      "success": "The inquiry has been sent",
      "error": "Failed to send the inquiry"
    }
  },
  "publicOffer": {
    "linkExpired": "Link expired",
    "linkInvalid": "Invalid link",
    "linkExpiredDescription": "This offer link has expired. Contact your account manager for a new link.",
    "linkInvalidDescription": "This offer link is invalid or has been revoked.",
    "success": {
      "brandName": "Grupa RW",
      "brandSubtitle": "Advertising offer",
      "title": "Thank you for accepting the offer",
      "description": "Your decision has been saved. We will confirm the availability of the selected media units and contact you separately once we receive confirmation.",
      "savedLabel": "Decision saved",
      "nextTitle": "What happens next",
      "steps": {
        "saved": {
          "title": "Acceptance saved",
          "description": "We received your selected media units and dates."
        },
        "availability": {
          "title": "We confirm availability",
          "description": "We will check the availability of the selected media units."
        },
        "contact": {
          "title": "We will contact you",
          "description": "We will share the confirmation and agree on the next steps."
        }
      },
      "closeHint": "You can safely close this page, or view the recorded decisions below.",
      "backToOfferAction": "View recorded decisions"
    }
  },
  "publicLink": {
    "generate": "Generate public link",
    "generateShort": "Generate link",
    "inactive": "No active link",
    "copy": "Copy link",
    "copyHint": "Click to copy",
    "regenerate": "Generate new",
    "revoke": "Revoke",
    "active": "Active",
    "expires": "Valid until {{date}}",
    "copied": "Link copied",
    "revoked": "Link revoked",
    "generated": "Link generated",
    "regenerateToCopy": "Generate a new link to copy",
    "autoPublishFailed": "Couldn't publish the offer before generating the link. Try again.",
    "viewedAt": "Viewed by client {{date}}",
    "notViewedYet": "Not viewed yet",
    "cancel": "Cancel",
    "regenerateDialog": {
      "title": "Generate a new link?",
      "body": "The client's current link will stop working. You'll be able to copy the new link right after it's generated.",
      "acknowledgement": "I understand the client's current link will stop working"
    },
    "revokeDialog": {
      "title": "Revoke the link?",
      "body": "The client's link will stop working immediately.",
      "acknowledgement": "I understand the client's link will stop working immediately"
    }
  },
  "status": {
    "DRAFT": "DRAFT",
    "SENT": "Sent",
    "ACCEPTED": "Accepted",
    "CONFIRMED": "Confirmed",
    "SOLD": "Sold",
    "EXPIRED": "Expired",
    "CANCELLED": "Cancelled"
  },
  "clientOfferReviewV2": {
    "readOnlyRecordedHint": "This decision was recorded when the offer was accepted and can no longer be changed.",
    "header": {
      "brandName": "Grupa RW",
      "loggedInAs": "Logged in as:",
      "versionPrefix": "version"
    },
    "banner": {
      "acceptedTitle": "Offer accepted. Thank you!",
      "acceptedDescription": "The offer owner received your response with per-unit decisions ({{count}} accepted, value {{value}}).",
      "rejectedTitle": "The offer was rejected.",
      "rejectedDescription": "The offer owner received your response and will get in touch.",
      "expiredTitle": "The offer has expired.",
      "expiredDescription": "Contact the offer owner to request a current version.",
      "previewTitle": "Version preview — archival view.",
      "previewDescription": "Every action is visible but inactive.",
      "pendingTitle": "The offer is awaiting your decision.",
      "statusAccepted": "Accepted",
      "statusRejected": "Rejected",
      "statusExpired": "Expired",
      "statusSent": "Sent"
    },
    "statusBanner": {
      "diffTitle": "What changed since version {{prevVersion}}",
      "diffCollapse": "Collapse",
      "diffShow": "Show changes ({{count}})",
      "diffTagPrice": "Price",
      "diffTagRemoved": "Removed",
      "diffTagAdded": "New"
    },
    "summaryStats": {
      "unitsLabel": "Units",
      "citiesUnit": "cities",
      "campaignLabel": "Campaign",
      "totalNetLabel": "Total net",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "pending": "Pending",
      "pendingHint": "Units without your decision yet. Accept or reject each one individually — decisions are submitted together with your offer response.",
      "acceptedValueLabel": "Accepted value:",
      "breakdownSummary": "{{accCount}} ({{pctAcc}}%) accepted · {{rejCount}} ({{pctRej}}%) rejected · {{pendCount}} ({{pctPend}}%) pending",
      "availableUnitsSuffix": "{{availCount}} available units"
    },
    "filterPanel": {
      "city": "City",
      "format": "Format type",
      "price": "Price",
      "priceUnit": "PLN",
      "voivodeship": "Voivodeship",
      "supplier": "Supplier",
      "width": "Width",
      "height": "Height",
      "dimensionUnit": "m",
      "panel": {
        "allLabel": "All",
        "searchPlaceholder": "Search…",
        "selectedCount": "Selected: {{count}}",
        "clearAriaLabel": "Clear filter {{fieldId}}",
        "clearAllLabel": "Clear filters",
        "addFilterLabel": "+ Add filter"
      },
      "range": {
        "minLabel": "Min",
        "maxLabel": "Max",
        "applyLabel": "Apply",
        "clearLabel": "Clear"
      }
    },
    "toolbar": {
      "searchPlaceholder": "Address, city, number…",
      "filterAll": "All",
      "filterAccepted": "Accepted",
      "filterRejected": "Rejected",
      "filterPending": "Pending",
      "photoModeAriaLabel": "Photo mode",
      "photoModeLabel": "Photos:",
      "photoModeLarge": "Large",
      "photoModeSmall": "Small",
      "photoModeNone": "None",
      "sortAriaLabel": "Sort order",
      "sortLabel": "Sort:",
      "sortByCity": "City",
      "sortByPrice": "Price",
      "sortByDecision": "Decision",
      "granularityAriaLabel": "Period granularity",
      "granularityLabel": "Granularity:",
      "granularityHalfMonth": "Half-months",
      "granularityMonth": "Months",
      "granularityWeek": "Weeks",
      "granularityDay": "Days",
      "selectAllAriaLabel": "Select all",
      "selectAllHint": "Select all (accept every available unit)",
      "clearAllAriaLabel": "Clear selection",
      "clearAllHint": "Clear selection (undo every decision)",
      "pageSizeAriaLabel": "Results per page",
      "pageSizeLabel": "Per page:",
      "pageSizeAllOption": "All",
      "pageSizeCustomAriaLabel": "Custom results per page",
      "pageSizeCustomPlaceholder": "Custom…"
    },
    "unitCard": {
      "soldLabel": "Sold",
      "acceptedBadge": "✓ Accepted",
      "rejectedBadge": "✕ Rejected",
      "priceConfirmationPending": "to be confirmed",
      "netSuffix": "net",
      "locateAction": "Show on map",
      "acceptAction": "Accept unit",
      "undoAcceptAction": "Undo acceptance",
      "acceptDisabledHint": "No available periods to select",
      "rejectAction": "Reject unit",
      "undoRejectAction": "Undo rejection",
      "lockedHint": "This unit has already been sold for this offer, so the decision is binding. Contact your salesperson to change it.",
      "seeDetails": "See details",
      "grwNumberLabel": "No.",
      "discountedPriceLabel": "Discounted price"
    },
    "periodChips": {
      "free": "free",
      "reserved": "reserved",
      "sold": "sold",
      "selected": "selected",
      "selectedRangeSummary": "{{selectedCount}} of {{totalCount}} periods selected",
      "toggleAriaLabel": "Period {{periodLabel}}",
      "willAcceptHint": "Selecting this period will accept this unit."
    },
    "photoBlock": {
      "zoomHint": "Click to enlarge photos",
      "soldLabel": "SOLD",
      "placeholderCaptionLarge": "unit photo — full frame",
      "placeholderCaptionSmall": "unit photo"
    },
    "unitList": {
      "noResultsTitle": "No units match these criteria",
      "clearFilters": "Clear filters"
    },
    "pagination": {
      "previous": "Previous page",
      "next": "Next page",
      "pageAriaLabel": "Page {{page}}"
    },
    "confirmationModals": {
      "selectAllTitle": "Accept every unit?",
      "selectAllBody": "This marks {{availCount}} available units as accepted (with default periods). Existing decisions will be overwritten. Nothing is sent yet — you submit the response separately.",
      "selectAllCancel": "Cancel",
      "selectAllConfirm": "Accept all",
      "clearAllTitle": "Clear every decision?",
      "clearAllBody": "This undoes the decision for {{accCount}} accepted and {{rejCount}} rejected units, along with their selected periods. This cannot be undone.",
      "clearAllCancel": "Cancel",
      "clearAllConfirm": "Clear decisions",
      "acceptOfferTitle": "Accept the offer (version {{versionNumber}})?",
      "acceptOfferBody": "We will send your response with per-unit decisions: {{accCount}} accepted, {{rejCount}} rejected, {{pendCount}} undecided. Accepted units value: {{value}} net.",
      "acceptOfferCancel": "Cancel",
      "acceptOfferConfirm": "Accept offer"
    },
    "lightbox": {
      "close": "Close",
      "previous": "Previous photo",
      "next": "Next photo",
      "frame1": "street-level view",
      "frame2": "close-up view",
      "frame3": "night view (illuminated)"
    },
    "mapPanel": {
      "fullscreenToggle": "Fullscreen",
      "growListWidth": "Widen the list",
      "growMapWidth": "Widen the map",
      "legendAccepted": "accepted",
      "legendRejected": "rejected",
      "legendDigital": "digital",
      "legendOther": "other",
      "legendSold": "sold"
    },
    "footerBar": {
      "disclaimer": "Per-unit decisions are submitted together with the response for the whole offer.",
      "summary": "{{accCount}} accepted · {{rejCount}} rejected · {{pendCount}} pending · value {{value}}",
      "accept": "Accept offer (version {{versionNumber}})",
      "customPeriodsChip": "with changed periods",
      "customPeriodsCount_one": "{{count}} unit with changed periods",
      "customPeriodsCount_other": "{{count}} units with changed periods",
      "customPeriodsTitle": "Changed periods",
      "customPeriodsRestoreHint": "Restores the proposed periods for every unit. This cannot be undone.",
      "restoreCustomPeriods": "Restore defaults",
      "acceptDisabledNoAcceptedHint": "No accepted units."
    },
    "inquiry": {
      "submit": "Send inquiry",
      "success": "Your period inquiry has been sent."
    }
  }
}
